export const credenciales = {
  account: '10020192',
  key: '6L3kGJE5SVAFqukeGIhHaFvKt5TGNs',
  token: '937a8a0cb08094d48a676f4e1b182588'
}